export const setting = state => key => state.settings[key] ? state.settings[key] : null
export const permissions = state => key => state.settings.permissions[key] ? state.settings.permissions[key] : null
export const roles = state => state.settings.roles.map(role => role)
export const areas = state => state.settings.areas.map(area => area)
export const lang = state => state.settings.lang ? state.settings.lang : 'en'
export const token = state => state.token
// shiseido data
export const dataready = state => state.options.brand.length && Object.keys(state.projects)
export const projects = state => state.indexes.map(id => state.projects[id]) || []
export const options = state => state.options
export const option = state => (name, id) => state.options[name].filter(o => o.id === id)
export const optionsLoaded = state => state.optionsLoaded
export const optionId = state => (name, value) => {
	const prop = state.options[name] ? state.options[name].find(o => o.label === value) : null
	return prop ? prop.id : null
}
export const optionLabel = state => (name, value) => {
	const prop = state.options[name] ? state.options[name].find(o => o.id === value) : null
	return prop ? prop.id : null
}
export const filterOptions = state => key => state.options[key] || []
export const project = state => id => state.projects[id]
export const projectProp = state => (id, key) => state.projects[id][key]
export const projectPicture = state => id => state.projects[id].avatarFile
export const typeOfProjectPerso = state => id => state.projects[id].typeOfProject.personalization
export const typeOfProjectItems = state => id => state.projects[id].typeOfProject.items
export const typeOfProjectBacklit = state => id => state.projects[id].typeOfProject.backlit
export const typeOfProjectType = state => id => state.projects[id].typeOfProject.type
export const countries = state => state.options.country ? state.options.country.filter(c => c.lat && c.lon) : []
export const suppliers = state => {
	const projects = state.indexes.map(id => state.projects[id]) || []
	return [...new Set(projects.map(p => p.supplier))]
}
export const projectsFileDownload = state => state.projectsFile.length ? state.projectsFile : false
export const supplierManufacturer = state => id => state.options.supplierManufacturer.find(s => s.id === id)
export const supplierManufacturers = state => array => state.options.supplierManufacturer.filter(supplier => array.includes(supplier.id))

// project keys
export const area = state => id => state.options.area.find(a => a.id === id)
export const zone = state => id => state.options.zone.find(z => z.id === id)
export const brand = state => id => state.options.brand.find(b => b.id === id)
export const country = state => id => state.options.country.find(c => c.id === id)
export const distributionChannel = state => id => state.options.distributionChannel.find(dc => dc.id === id)
export const generalFloorPlan = state => id => state.options.generalFloorPlan.find(gfp => gfp.id === id)
export const groupSpacePlan = state => id => state.options.groupSpacePlan.find(gsp => gsp.id === id)
export const projectLabel = state => id => state.options.typeOfProjectLabel.find(l => l.id === id)
export const projectStatus = state => id => state.options.projectStatus.find(ps => ps.id === id)
export const projectType = state => id => state.options.typeOfProjectType.find(pt => pt.id === id)
export const specificNeed = state => id => state.options.specificNeed.find(sn => sn.id === id)
export const step = state => id => state.options.step.find(s => s.id === id)
export const typeOfStore = state => id => state.options.typeOfStore.find(st => st.id === id)
export const budget = state => id => state.options.budgetInK.find(bd => bd.id === id)
export const makeupCollection = state => id => state.options.makeupCollection.find(muc => muc.id === id)
export const fragranceCollection = state => id => state.options.fragrancesCollection.find(frgc => frgc.id === id)
export const fragrance = state => id => state.options.frg.find(frg => frg.id === id)
export const frgMuAxe = state => id => state.options.frgMuAxe.find(axe => axe.id === id)
export const frg = state => id => state.options.frg.find(frg => frg.id === id)
export const mu = state => id => state.options.mu.find(mu => mu.id === id)



// WEBPACK FOOTER //
// ./src/store/getters.js